import React, { Component } from 'react';
import Proptypes from 'prop-types';
import TemplateEditorModal from 'containers/Mail/Templates/TemplateEditorModal';
import { Row, Col, Icon, Button } from 'components/ui';
import './style.css';
import TemplateSelector from './TemplateSelector';

class SelectTemplate extends Component {
  state = {
    showTemplateModal: false,
  };

  componentDidUpdate(prevProps) {
    this.setAddedTemplate(prevProps);
  }

  setAddedTemplate = prevProps => {
    if (prevProps.newTemplateId !== this.props.newTemplateId) {
      this.handleTemplateChange(this.props.newTemplateId);
    }
  };

  handleShowModal = () => {
    this.setState({ showTemplateModal: true });
  };

  handleHideModal = () => {
    this.setState({ showTemplateModal: false });
  };

  handleTemplateChange = template => {
    if (this.props.onUpdateSelectedTemplate)
      this.props.onUpdateSelectedTemplate(template?.id);
    if (this.props.onUpdateSelectedTemplateData)
      this.props.onUpdateSelectedTemplateData(template);
  };

  handleAddTemplate = template => {
    this.handleHideModal();
    this.props.onAddTemplate(template);
  };

  render() {
    const { showTemplateModal } = this.state;
    const {
      error,
      templates,
      selectedTemplateId,
      disabled,
      name,
      onBlur,
    } = this.props;

    return (
      <div>
        <Row gutter={8}>
          <Col span={15}>
            <TemplateSelector
              disabled={disabled}
              error={error}
              helperTxt={error}
              name={name}
              selectedTemplateId={selectedTemplateId}
              showSearch
              onBlur={onBlur}
              onTemplateChange={this.handleTemplateChange}
            />
          </Col>
          <Col span={7}>
            <Button
              className="select-template__btn"
              disabled={disabled}
              onClick={this.handleShowModal}
            >
              <Icon type="plus-circle" />
              &nbsp;New Template
            </Button>
          </Col>
        </Row>

        <TemplateEditorModal
          isVisible={showTemplateModal}
          template={{}}
          templates={templates}
          onHideModal={this.handleHideModal}
          onSaveTemplate={this.handleAddTemplate}
        />
      </div>
    );
  }
}

SelectTemplate.defaultProps = {
  error: '',
  selectedTemplateId: -1,
};

SelectTemplate.propTypes = {
  disabled: Proptypes.bool,
  error: Proptypes.string,
  newTemplateId: Proptypes.number.isRequired,
  selectedTemplateId: Proptypes.number,
  templates: Proptypes.array.isRequired,
  onAddTemplate: Proptypes.func.isRequired,
  onUpdateSelectedTemplate: Proptypes.func,
  onUpdateSelectedTemplateData: Proptypes.func,
};

export default SelectTemplate;
